import * as classnames from "classnames";
import { isEqual } from "lodash";
import * as React from "react";

import { Modal, Icon, Msg } from "../../../../shared/components";
import { ApplicantExamModel } from "../../../../shared/models";
import { ChallengeResultStatus } from "../../../../shared/services/enums";

/**
 * Prop interface
 */
export interface SubmitExamProps {
  isOpen: boolean;
  exam: ApplicantExamModel;
  onSubmit?: () => void;
  onCancel?: () => void;
}

/**
 * Page component
 */
class SubmitExam extends React.Component<SubmitExamProps> {
  constructor(props: SubmitExamProps) {
    super(props);
  }

  public shouldComponentUpdate(nextProps: SubmitExamProps) {
    return !isEqual(nextProps, this.props);
  }

  public render() {
    const { isOpen, onCancel, onSubmit, exam } = this.props;

    const rootStyle = classnames("code-submit-exam");

    return (
      <Modal
        className={rootStyle}
        size="large"
        title={<Msg id={"submit-exam.title"} />}
        isOpen={isOpen}
        onClose={onCancel}
        onClickCancel={onCancel}
        onClickOk={onSubmit}
        okButtonType="warning"
        okButtonLabel={<Msg id={"button.submitExam"} />}
        okButtonAriaLabel="Submit Exam"
        ariaLabel="Submit Exam"
      >
        <div className="code-submit-exam__body">
          <div className="code-submit-exam__header">
            <div className="code-submit-exam__left">
              <Icon
                type="exclamation-triangle"
                iconClassName="fa-3x"
                size="large"
              />
            </div>
            <div className="code-submit-exam__right">
              <div className="code-submit-exam__text">
                <p>
                  <Msg id={"submit-exam.text1"} />
                </p>
                <p>
                  <Msg id={"submit-exam.text2"} />
                </p>
              </div>
              <p>
                <strong>
                  <Msg id="submit-exam.currentAnswers" />
                </strong>
              </p>
              <ul className="code-submit-exam__challenges">
                {exam.challengesSets.map((challengeSet, challengeSetIndex) => {
                  const challenges = challengeSet.challenges.map(
                    (challenge, challengeIndex) => {
                      const statusStyle = classnames(
                        "code-submit-exam__challenge-status",
                        {
                          "code-submit-exam__challenge-not-finished":
                            !exam.isChallengeFinished(challenge.id),
                        },
                      );
                      return (
                        <li
                          key={challenge.id}
                          className="code-submit-exam__challenge"
                        >
                          <div className="is-wrap">{challenge.title}</div>
                          <div className={statusStyle}>
                            {ChallengeResultStatus.toArrangeString(
                              exam.getResultByChallengeId(challenge.id).status,
                            )}
                          </div>
                        </li>
                      );
                    },
                  );
                  return challengeSet.isOptionalSet ? (
                    <li
                      key={challengeSetIndex}
                      className="code-submit-exam__challenge-set"
                    >
                      <Msg id="challenge.optional" />
                      <ul className="code-submit-exam__challenges">
                        {challenges}
                      </ul>
                    </li>
                  ) : (
                    challenges
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default SubmitExam;
